module.exports = __webpack_public_path__ + "static/media/addUserGroup.7db9d985.svg";